import React, { ReactNode } from 'react';
import { Paper, SxProps, useTheme } from '@mui/material';

interface Props {
  sx?: SxProps;
  children: ReactNode;
  isMobile: boolean;
}

export function AppPaper({ sx, children, isMobile }: Props): JSX.Element {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        ...sx,
        p: 2,
        pb: 0.5,
        mb: 5,

        [theme.breakpoints.down('sm')]: {
          background: 'transparent',
          boxShadow: 'none',
          mb: 1,
        },
      }}
      elevation={isMobile ? 0 : 1}
    >
      {children}
    </Paper>
  );
}
